// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.pdf-preview-main {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.75);
    z-index: 10;
}
.close-icon {
    position: absolute;
    right: 20px;
    top: 20px;
    height: 20px;
    width: 200x;
}
.top-nav {
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 16px;
    color: #fff;
    top: 0;
    left: 0;
    width: 100%;
    height: 60px;
    background: #000;
    z-index: 11;
}

.bottom-nav {
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 16px;
    color: #fff;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60px;
    background: #000;
    z-index: 11;
}

.download-btn,
.submit-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 16px;
    width: 200px;
    height: 40px;
    cursor: pointer;
}

.pdf-container {
    position: fixed;
    width: 100%;
    top: 60px;
    /* height: calc(100% - 120px); */
    overflow-y: scroll;
    z-index: 12;
}

.pdf-container .spin-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
}

.page-sign-layer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.sign-mark, .sign-mark-date {
    display: flex;
    align-items: flex-end;
    color: darkblue;
}


.sign-mark:hover, .sign-mark-date:hover {
    background: lightblue;
    opacity: 0.3;
    cursor: pointer;
}

/* .sign-pad {
    z-index: 100;
    bottom: 0;
    background: #f6f6f6;
    padding: 23px;
} */

.cancel-button,
.insert-button {
    width: 148px;
    height: 44px;
    border-radius: 4px;
    font-weight: 600;
}
.cancel-button {
    border: 1px solid #325ceb;
    color: #325ceb;
}
.sign-pad .action-button-group {
    display: flex;
    justify-content: center;
    margin-top: 10px;
}
.insert-button {
    margin-left: 10px;
}
.sign-thumb-wrapper {
    display: flex;
}
.sign-thumb {
    background: #325ceb;
    cursor: pointer;
    color: white;
    width: 100px;
    height: 40px;
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items: center;

}
.sign-thumb-triangle {
    cursor: pointer;
    background: #325ceb;
    width: 40px;
    height: 40px;
    clip-path: polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%);
    margin-left: -20px;
}
.signature-terms-modal .ant-modal-footer {
    text-align: center;
}
.sign-pad .signature-terms-link {
    text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/components/PDFPreview/PDFPreview.css"],"names":[],"mappings":";AACA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,+BAA+B;IAC/B,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,YAAY;IACZ,WAAW;AACf;AACA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,SAAS;IACT,OAAO;IACP,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,WAAW;AACf;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,SAAS;IACT,gCAAgC;IAChC,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;AAChB;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,eAAe;AACnB;;;AAGA;IACI,qBAAqB;IACrB,YAAY;IACZ,eAAe;AACnB;;AAEA;;;;;GAKG;;AAEH;;IAEI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,aAAa;AACjB;AACA;IACI,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;AAEvB;AACA;IACI,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,sDAAsD;IACtD,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,0BAA0B;AAC9B","sourcesContent":["\n.pdf-preview-main {\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    background: rgba(0, 0, 0, 0.75);\n    z-index: 10;\n}\n.close-icon {\n    position: absolute;\n    right: 20px;\n    top: 20px;\n    height: 20px;\n    width: 200x;\n}\n.top-nav {\n    position: fixed;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 700;\n    font-size: 16px;\n    color: #fff;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 60px;\n    background: #000;\n    z-index: 11;\n}\n\n.bottom-nav {\n    position: fixed;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 700;\n    font-size: 16px;\n    color: #fff;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 60px;\n    background: #000;\n    z-index: 11;\n}\n\n.download-btn,\n.submit-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 700;\n    font-size: 16px;\n    width: 200px;\n    height: 40px;\n    cursor: pointer;\n}\n\n.pdf-container {\n    position: fixed;\n    width: 100%;\n    top: 60px;\n    /* height: calc(100% - 120px); */\n    overflow-y: scroll;\n    z-index: 12;\n}\n\n.pdf-container .spin-wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    width: 100%;\n}\n\n.page-sign-layer {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n.sign-mark, .sign-mark-date {\n    display: flex;\n    align-items: flex-end;\n    color: darkblue;\n}\n\n\n.sign-mark:hover, .sign-mark-date:hover {\n    background: lightblue;\n    opacity: 0.3;\n    cursor: pointer;\n}\n\n/* .sign-pad {\n    z-index: 100;\n    bottom: 0;\n    background: #f6f6f6;\n    padding: 23px;\n} */\n\n.cancel-button,\n.insert-button {\n    width: 148px;\n    height: 44px;\n    border-radius: 4px;\n    font-weight: 600;\n}\n.cancel-button {\n    border: 1px solid #325ceb;\n    color: #325ceb;\n}\n.sign-pad .action-button-group {\n    display: flex;\n    justify-content: center;\n    margin-top: 10px;\n}\n.insert-button {\n    margin-left: 10px;\n}\n.sign-thumb-wrapper {\n    display: flex;\n}\n.sign-thumb {\n    background: #325ceb;\n    cursor: pointer;\n    color: white;\n    width: 100px;\n    height: 40px;\n    font-weight: 600;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n}\n.sign-thumb-triangle {\n    cursor: pointer;\n    background: #325ceb;\n    width: 40px;\n    height: 40px;\n    clip-path: polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%);\n    margin-left: -20px;\n}\n.signature-terms-modal .ant-modal-footer {\n    text-align: center;\n}\n.sign-pad .signature-terms-link {\n    text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
